module.exports = ".list-divider {\n  padding-bottom: 15px; }\n\n.tools {\n  max-height: 100%; }\n\n.tools .mat-icon-button {\n    height: 32px;\n    line-height: 32px; }\n\np {\n  overflow: auto;\n  word-wrap: break-word;\n  /* old name */\n  overflow-wrap: break-word; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pillar/common/components/confirmation-dialog.component.scss
// module id = ./src/app/pillar/common/components/confirmation-dialog.component.scss
// module chunks = main